import type {
  ImageWithMetadata,
  SlideMasterProps,
  SlideMasterPropsObject,
} from '@features/powerpoint';
import { resizeToHeight, inmarketLogoV2 } from '@features/powerpoint';
import { contentSlideBackgroundV2 } from '../images';

export const TITLE_AND_CONTENT = 'InMarket_Title and Content';
export const TITLE_AND_CONTENT_NO_LOGO = 'InMarket_Title and Content - No Logo';

const SLIDE_WIDTH = 13.33;
const BRAND_LOGO_HEIGHT = 0.82;
const BRAND_LOGO_Y_POSITION = 0.25;

const brandLogoObject = (
  brandLogoWithMetadata: ImageWithMetadata | null
): SlideMasterPropsObject[] => {
  if (!brandLogoWithMetadata) return [];

  const resized = resizeToHeight(brandLogoWithMetadata, BRAND_LOGO_HEIGHT);
  const yPosition =
    resized.height < BRAND_LOGO_HEIGHT
      ? BRAND_LOGO_Y_POSITION + (BRAND_LOGO_HEIGHT - resized.height) / 2
      : BRAND_LOGO_Y_POSITION;

  return [
    {
      image: {
        data: resized.data,
        x: SLIDE_WIDTH - resized.width - 0.22,
        y: yPosition,
        w: resized.width,
        h: resized.height,
      },
    },
  ];
};

const footerLogo: SlideMasterPropsObject = {
  image: {
    path: inmarketLogoV2,
    x: 0.42,
    y: 7.17,
    w: 1.16,
    h: 0.2,
  },
};

export const slideMasterV2 = (
  brandLogoWithMetadata: ImageWithMetadata | null
): SlideMasterProps => ({
  title: TITLE_AND_CONTENT,
  background: { path: contentSlideBackgroundV2 },
  objects: [footerLogo, ...brandLogoObject(brandLogoWithMetadata)],
});

export const slideMasterNoLogoV2 = (): SlideMasterProps => ({
  title: TITLE_AND_CONTENT_NO_LOGO,
  background: { path: contentSlideBackgroundV2 },
  objects: [],
});
